import {
  AUTH_LOGIN,
  AUTH_LOGOUT,
  CHANGE_USER_WORK_STATUS,
  CREATE_USER,
  EDIT_BALANCE,
  EDIT_SUPPORT_LIMIT,
  EDIT_USER,
  EDIT_USER_MASS,
  LOAD_BALANCE_HISTORY,
  LOAD_BALANCE_USERS, LOAD_FINISHED_HISTORY, LOAD_FINISHED_USERS,
  LOAD_USERS_LIST,
  RESET_SUPPORT_LIMIT,
} from './user';
import {
  LOAD_SETTINGS,
  LOAD_USER_BALANCE,
  UPDATE_SETTING,
  LOAD_EXCHANGES, LOAD_ACTIONS_STATS, LOAD_DEEPLINK_AND_QR_SETTINGS, UPDATE_DEEPLINK_AND_QR_SETTINGS,
} from './settings';
import {
  ADD_AD, ADD_ORDER_COMMENT,
  CANCEL_CLAIM,
  CANCEL_ORDER, DELETE_ORDER_COMMENT,
  EDIT_ORDER,
  FINISH_ORDER,
  LOAD_ADS_LIST,
  LOAD_DEALS_LIST,
  LOAD_ORDERS_LIST,
  OPEN_CLAIM, RESTART_FINISH_ERROR_ORDERS, SWITCH_NOTE,
} from "./orders";
import { LOAD_CLAIMS } from "./claims";
import {
  ADD_BLACK_LIST_REQUISITE,
  ADD_BLACK_LIST_USER,
  DELETE_BLACK_LIST_REQUISITE,
  DELETE_BLACK_LIST_USER,
  DISABLE_INTERBANK,
  DISABLE_TRAFFIC_SPILL,
  EDIT_EXCHANGE_ACTIVE,
  EDIT_EXCHANGE_MIN_AMOUNT,
  EDIT_TRAFFIC_SPILL_AMOUNT,
  ENABLE_INTERBANK,
  ENABLE_TRAFFIC_SPILL,
  GET_EXCHANGE_SETTINGS,
  LOAD_BLACK_LIST_REQUISITES,
  LOAD_BLACK_LIST_USERS,
  LOAD_EXCHANGE_INFO,
  LOAD_INTERBANKS,
  LOAD_QR_INTERBANKS,
  EDIT_INTERBANK_RATE_PERCENT,
  LOAD_EXCHANGE_STATS,
  LOAD_BANKS_LIST,
  EDIT_EXCHANGE_MAX_AMOUNT, EDIT_EXCHANGE_PAYMENT_SYSTEM, CHANGE_EXCHANGE_ONLINE_STATUS
} from './exchange';


const path = {
  [AUTH_LOGIN]: 'api/users/login',
  [AUTH_LOGOUT]: 'api/users/logout',
  [LOAD_USERS_LIST]: 'api/users',
  [CREATE_USER]: 'api/users',
  [EDIT_USER]: 'api/users/:id:',
  [EDIT_BALANCE]: 'api/users/:id:/balance',
  [EDIT_SUPPORT_LIMIT]: 'api/users/:id:/limit/edit',
  [RESET_SUPPORT_LIMIT]: 'api/users/:id:/limit/reset',
  [LOAD_ORDERS_LIST]: 'api/orders',
  [EDIT_ORDER]: 'api/orders/:id:',
  [FINISH_ORDER]: 'api/orders/:id:/finish',
  [LOAD_SETTINGS]: 'api/settings/global',
  [UPDATE_SETTING]: 'api/settings/global',
  [LOAD_DEEPLINK_AND_QR_SETTINGS]: 'api/settings/deeplink-qr',
  [UPDATE_DEEPLINK_AND_QR_SETTINGS]: 'api/settings/deeplink-qr',
  [LOAD_ADS_LIST]: 'api/ads',
  [ADD_AD]: 'api/orders/ad/:id:',
  [LOAD_DEALS_LIST]: 'api/orders/:id:/deals',
  [OPEN_CLAIM]: 'api/orders/:id:/claim',
  [CANCEL_CLAIM]: 'api/orders/:id:/claim',
  [LOAD_CLAIMS]: 'api/claims/:category:',
  [EDIT_USER_MASS]: 'api/users/settings/mass',
  [CHANGE_USER_WORK_STATUS]: 'api/users/settings/work_status/:status:',
  [LOAD_USER_BALANCE]: 'api/user/balance',
  [CANCEL_ORDER]: 'api/orders/:id:/cancel',
  [LOAD_FINISHED_HISTORY]: 'api/stats/finished/history',
  [LOAD_FINISHED_USERS]: 'api/stats/finished/users',
  [LOAD_EXCHANGE_INFO]: 'api/exchange/info',
  [GET_EXCHANGE_SETTINGS]: 'api/exchange/info/direct',
  [EDIT_EXCHANGE_ACTIVE]: 'api/exchange/settings/active',
  [EDIT_EXCHANGE_MIN_AMOUNT]: 'api/exchange/settings/min_amount',
  [EDIT_EXCHANGE_MAX_AMOUNT]: 'api/exchange/settings/max_amount',
  [EDIT_EXCHANGE_PAYMENT_SYSTEM]: 'api/exchange/settings',
  [CHANGE_EXCHANGE_ONLINE_STATUS]: 'api/exchange/settings/online',
  [ADD_BLACK_LIST_USER]: 'api/blacklist',
  [DELETE_BLACK_LIST_USER]: 'api/blacklist',
  [LOAD_EXCHANGES]: 'api/settings/exchanges',
  [LOAD_BLACK_LIST_USERS]: 'api/blacklist/users',
  [ADD_BLACK_LIST_USER]: 'api/blacklist/users',
  [DELETE_BLACK_LIST_USER]: 'api/blacklist/users',
  [LOAD_BLACK_LIST_REQUISITES]: 'api/blacklist/requisites',
  [ADD_BLACK_LIST_REQUISITE]: 'api/blacklist/requisites',
  [DELETE_BLACK_LIST_REQUISITE]: 'api/blacklist/requisites',
  [SWITCH_NOTE]: 'api/orders/:id:/notes/:type:',
  [ADD_ORDER_COMMENT]: 'api/orders/:id:/comments',
  [DELETE_ORDER_COMMENT]: 'api/orders/:id:/comments',
  [LOAD_ACTIONS_STATS]: 'api/users/actions',
  [RESTART_FINISH_ERROR_ORDERS]: 'api/service/orders/restart-finish-error',
  [LOAD_INTERBANKS]: 'api/exchange/interbanks',
  [LOAD_QR_INTERBANKS]: 'api/exchange/interbanks',
  [ENABLE_INTERBANK]: 'api/exchange/interbanks/enable/:id:',
  [DISABLE_INTERBANK]: 'api/exchange/interbanks/disable/:id:',
  [EDIT_TRAFFIC_SPILL_AMOUNT]: 'api/exchange/interbanks/traffic-spill-amount/:id:',
  [EDIT_INTERBANK_RATE_PERCENT]: 'api/exchange/interbanks/rate-percent/:id:',
  [ENABLE_TRAFFIC_SPILL]: 'api/exchange/interbanks/traffic-spill-enable/:id:',
  [DISABLE_TRAFFIC_SPILL]: 'api/exchange/interbanks/traffic-spill-disable/:id:',
  [LOAD_EXCHANGE_STATS]: 'api/exchange/stats',
  [LOAD_BANKS_LIST]: 'api/exchange/banks',
};
export default path;
